import React from 'react'
import { Col, Row } from 'antd'
import CreateOrganizationCard from './CreateOrganizationCard'
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle'

const OrganizationsSection = () => {
    useDocumentTitle('Organizations')

    return (
        <Row gutter={[24, 24]}>
            <Col span={8}>
                <CreateOrganizationCard />
            </Col>
        </Row>
    )
}

export default OrganizationsSection
